import {
  Avatar,
  Dropdown,
  Space,
  Typography
} from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrentEmail } from '../../../redux/auth/selectors';
import { logout } from '../../../redux/auth/actions';

/** Shared account control for public workspace flows. */
export default function WorkspaceAccountMenu() {
  const email = useSelector(selectCurrentEmail);
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const initials = (email || '?').slice(0, 1).toUpperCase();

  const signOut = async () => {
    await dispatch(logout());
    navigate('/login');
  };

  return <Dropdown
    menu={{
      items: [{
        key: 'logout',
        icon: <LogoutOutlined />,
        label: 'Sign out',
        onClick: signOut
      }]
    }}
    trigger={['click']}
  >
    <button
      type="button"
      className="flex items-center gap-3 rounded-lg px-2 py-1 text-left hover:bg-slate-100"
    >
      <Avatar size="small" className="bg-blue-600">{initials}</Avatar>
      <Space direction="vertical" size={0} className="hidden sm:flex">
        <Typography.Text
          className="text-xs text-slate-500"
        >Signed in as</Typography.Text>
        <Typography.Text
          ellipsis
          className="max-w-[220px] text-sm"
        >{email}</Typography.Text>
      </Space>
    </button>
  </Dropdown>;
}
